import React, { Fragment, useState, useEffect, useRef } from "react";
import Moment from "react-moment";

import ToggleButton from "../../PlayerButtons/ToggleButton";
import VolumeGreen from "../Innovators/VolumeGreen";
import VolumeRed from "../Mentors/VolumeRed";
import Volume from "../Employers/Volume";
import ProgressGreen from "../Innovators/ProgressGreen";
import ProgressRed from "../Mentors/ProgressRed";
import Progress from "../Employers/Progress";
import FontAwesomeIcon from "./Icon";

const ReportedUserItem = ({
  user,
  setShowDetails,
  showDetails,
  deleteReport,
}) => {
  const videoRef = useRef(null);
  const videoPlayerRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  return (
    <Fragment>
      <div className="report-item">
        <div
          className={`user-section-alt ${!showDetails && "margin-bottom-five"}`}
        >
          <div className="setting-user-container">
            <div className="setting-friend-user-avi-container">
              <div
                className={`avi-color-border ${
                  user && user.role === "innovator"
                    ? "green"
                    : user && user.role === "mentor"
                    ? "red"
                    : user && user.role === "employer"
                    ? "blue"
                    : ""
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.avatar}`}
                  className="friend-user-avi"
                  alt="avi"
                />
              </div>
            </div>
            <div className="friend-user-info">
              <div className="online-info">
                <ul className="user-online-items">
                  <li className="user-online-item">
                    <span
                      className={`${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      } name-font`}
                    >
                      {user.channelid}
                    </span>
                  </li>
                  <li className="user-online-item">
                    {user.firstname} {user.lastname}
                  </li>
                  <li className="user-online-item">{user.jobtitle}</li>
                  <li className="user-online-item">
                    {user && user.location.state},{" "}
                    {user && user.location.country}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="setting-friends-buttons-container">
            <div className="friend-button-container">
              <button
                onClick={() => {
                  if (showDetails) {
                    setShowDetails(false);
                  } else {
                    setShowDetails(true);
                  }
                }}
                className={`setting-friend-button ${
                  user && user.role === "innovator"
                    ? "background-green"
                    : user && user.role === "mentor"
                    ? "background-red"
                    : user && user.role === "employer"
                    ? "background-blue"
                    : ""
                }`}
              >
                <i className="fa-solid fa-scroll mx-5"></i>
                Details
              </button>
            </div>
            <div className="friend-button-container">
              <button
                onClick={() => deleteReport(user._id)}
                className={`setting-friend-button ${
                  user && user.role === "innovator"
                    ? "background-green"
                    : user && user.role === "mentor"
                    ? "background-red"
                    : user && user.role === "employer"
                    ? "background-blue"
                    : ""
                }`}
              >
                <i className="fa-solid fa-times mx-5"></i>
                Delete
              </button>
            </div>
          </div>
        </div>
        {showDetails && (
          <div className="report-details-container">
            <div
              className={`report-reason ${
                user && user.reporting_user_role === "innovator"
                  ? "green"
                  : user && user.reporting_user_role === "mentor"
                  ? "red"
                  : user && user.reporting_user_role === "employer"
                  ? "blue"
                  : ""
              } bold`}
            >
              <p>Reported By</p>
              <p>Report Reason</p>
              <p>Reported Message/Post</p>
            </div>
            <div className="reporting-user-container">
              <div className="flex-only">
                <div className="setting-friend-user-avi-container">
                  <div
                    className={`avi-color-border ${
                      user && user.reporting_user_role === "innovator"
                        ? "green"
                        : user && user.reporting_user_role === "mentor"
                        ? "red"
                        : user && user.reporting_user_role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  >
                    <img
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${user.reporting_user_avatar}`}
                      className="friend-user-avi"
                      alt="avi"
                    />
                  </div>
                </div>
                <div className="friend-user-info">
                  <div className="online-info">
                    <ul className="user-online-items">
                      <li className="user-online-item">
                        <span
                          className={`${
                            user && user.reporting_user_role === "innovator"
                              ? "green"
                              : user && user.reporting_user_role === "mentor"
                              ? "red"
                              : user && user.reporting_user_role === "employer"
                              ? "blue"
                              : ""
                          } name-font`}
                        >
                          {user.reporting_user_channelid}
                        </span>
                      </li>
                      <li className="user-online-item">
                        {user.reporting_user_firstname}{" "}
                        {user.reporting_user_lastname}
                      </li>
                      <li className="user-online-item">
                        {user.reporting_user_jobtitle}
                      </li>
                      <li className="user-online-item">
                        {user && user.reporting_user_location.state},{" "}
                        {user && user.reporting_user_location.country}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className={`text-center ${
                  user && user.reporting_user_role === "innovator"
                    ? "green"
                    : user && user.reporting_user_role === "mentor"
                    ? "red"
                    : user && user.reporting_user_role === "employer"
                    ? "blue"
                    : ""
                } bold`}
              >
                <p>
                  {user.racism
                    ? "Racism"
                    : user.inappropriate
                    ? "Inappropriate"
                    : user.spam
                    ? "Spam"
                    : user.impersonation
                    ? "Impersonation"
                    : user.threat
                    ? "Threat"
                    : user.other
                    ? "Other"
                    : ""}
                </p>
              </div>
              <div className=" text-center white italicized bold">
                {user.image !== "" && (
                  <img
                    src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_images/${user.image}`}
                    alt="media"
                    className="reported-media"
                  />
                )}
                {user.gif !== "" && (
                  <img src={user.gif} alt="media" className="reported-media" />
                )}
                {user.video !== "" && (
                  <div className="media-post-report" ref={videoPlayerRef}>
                    <div
                      className={
                        showOverlay
                          ? "alt-video-overlay-pause-reports"
                          : "video-overlay-reports"
                      }
                    >
                      <div className="alt-left-controls">
                        <ul className="controls">
                          {user && user.role === "innovator" && (
                            <VolumeGreen
                              className="Rac__volume"
                              onChange={(level) => {
                                const volume = level / 100;
                                videoRef.current.volume = volume;
                                videoRef.current.muted = volume === 0;
                              }}
                            />
                          )}
                          {user && user.role === "mentor" && (
                            <VolumeRed
                              className="Rac__volume"
                              onChange={(level) => {
                                const volume = level / 100;
                                videoRef.current.volume = volume;
                                videoRef.current.muted = volume === 0;
                              }}
                            />
                          )}
                          {user && user.role === "employer" && (
                            <Volume
                              className="Rac__volume"
                              onChange={(level) => {
                                const volume = level / 100;
                                videoRef.current.volume = volume;
                                videoRef.current.muted = volume === 0;
                              }}
                            />
                          )}
                        </ul>
                      </div>
                      <ToggleButton
                        className="alt-center-controls-reports"
                        value={() =>
                          videoRef.current && !videoRef.current.paused
                        }
                        onChange={(active) => {
                          if (!active) {
                            return videoRef.current.pause();
                          }

                          return videoRef.current.play();
                        }}
                      >
                        {(active) => {
                          if (
                            currentTime > 0.1 &&
                            currentTime < duration &&
                            active
                          ) {
                            setshowOverlay(true);
                            return (
                              <i
                                className={`far fa-pause-circle ${
                                  user && user.role === "innovator"
                                    ? "green"
                                    : user && user.role === "mentor"
                                    ? "red"
                                    : user && user.role === "employer"
                                    ? "blue"
                                    : ""
                                } fa-3x`}
                                onClick={() => videoRef.current.pause()}
                              ></i>
                            );
                          } else {
                            setshowOverlay(false);
                          }
                          if (currentTime === duration) {
                            setCurrentTime(0);
                          } else if (currentTime === 0 && !active) {
                            return (
                              <i
                                className={`far fa-play-circle ${
                                  user && user.role === "innovator"
                                    ? "green"
                                    : user && user.role === "mentor"
                                    ? "red"
                                    : user && user.role === "employer"
                                    ? "blue"
                                    : ""
                                } fa-3x`}
                                onClick={() => videoRef.current.play()}
                              ></i>
                            );
                          }
                          return (
                            <i
                              className={`far fa-play-circle ${
                                user && user.role === "innovator"
                                  ? "green"
                                  : user && user.role === "mentor"
                                  ? "red"
                                  : user && user.role === "employer"
                                  ? "blue"
                                  : ""
                              } fa-3x`}
                              onClick={() => videoRef.current.play()}
                            ></i>
                          );
                        }}
                      </ToggleButton>
                      {user && user.role === "innovator" && (
                        <ProgressGreen
                          className="Rac__progress-bar"
                          initial={0}
                          time={currentTime}
                          duration={duration}
                          onSkip={(time) =>
                            (videoRef.current.currentTime = time)
                          }
                        />
                      )}
                      {user && user.role === "mentor" && (
                        <ProgressRed
                          className="Rac__progress-bar"
                          initial={0}
                          time={currentTime}
                          duration={duration}
                          onSkip={(time) =>
                            (videoRef.current.currentTime = time)
                          }
                        />
                      )}
                      {user && user.role === "employer" && (
                        <Progress
                          className="Rac__progress-bar"
                          initial={0}
                          time={currentTime}
                          duration={duration}
                          onSkip={(time) =>
                            (videoRef.current.currentTime = time)
                          }
                        />
                      )}
                      <div className="icon-flex-expand-settings">
                        <ToggleButton
                          className="Rac__screen-toggle"
                          initial={document.fullscreenElement}
                          onChange={(active) => {
                            if (!active && KeyboardEvent.key === "Escape") {
                              return document.exitFullscreen();
                            }

                            return videoPlayerRef.current.requestFullscreen({
                              navigationUI: "hide",
                            });
                          }}
                        >
                          {(active) => {
                            if (!active) {
                              return (
                                <FontAwesomeIcon
                                  icon="expand"
                                  size="lg"
                                  className={`mt-4 ${
                                    user && user.role === "innovator"
                                      ? "green"
                                      : user && user.role === "mentor"
                                      ? "red"
                                      : user && user.role === "employer"
                                      ? "blue"
                                      : ""
                                  }`}
                                />
                              );
                            }

                            if (active) {
                              return (
                                <FontAwesomeIcon
                                  icon="compress"
                                  size="lg"
                                  className={`mt-4 ${
                                    user && user.role === "innovator"
                                      ? "green"
                                      : user && user.role === "mentor"
                                      ? "red"
                                      : user && user.role === "employer"
                                      ? "blue"
                                      : ""
                                  }`}
                                />
                              );
                            }
                          }}
                        </ToggleButton>
                      </div>
                    </div>
                    <video
                      ref={videoRef}
                      src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/post_videos/${user.video}`}
                      alt="media"
                      className="post-text-media"
                    ></video>
                  </div>
                )}
                <p>"{user.reported_text}"</p>
              </div>
            </div>
            <p className="reporting-user-context ">"{user.text}"</p>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default ReportedUserItem;
